import { ChangeDetectorRef, Component, ElementRef, HostListener, Injectable, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { ToastrService } from 'ngx-toastr';

import { CommonService } from 'app/common/services/Common.service';
import { PushNotificationsService } from 'app/common/services/Notifycation.service';
import { environment } from 'environments/environment';
import * as _ from 'lodash';
import { BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { ChatService } from '../../../../common/services/Chat.service';
import { ContactService } from '../../../../common/services/Contact.service';
import { DownloadService } from '../../../../common/services/Download.service';
import { EvsUserService } from '../../../../common/services/EvsUser.service';
import { RoomService } from '../../../../common/services/Room.service';
import { SocketService } from '../../../../common/services/Socket.service';
import { TemplateService } from '../../../../common/services/Template.service';
import { TicketService } from '../../../../common/services/Ticket.service';
import { UploadService } from '../../../../common/services/Upload.service';
import { UserService } from '../../../../common/services/User.service';
import { ChatFilterType, isValidFilter } from './side-bar/sidebar.const';
import { Observable } from 'rxjs';
import { TimeWorker } from '../../../../common/utils/timeWorker';
import { CoreTemplateService } from '../../../../common/services/CoreTemplate.service';
import { ChatListener } from './chat.listener';
import { BaseComponent } from '../../../../components/base.component';
import { showPhoneNumberInString } from '../../../../common/utils/common';

declare var $: any;

@Component({
  moduleId: module.id,
  selector: 'chats',
  templateUrl: './chat.template.html',
  styleUrls: ['../../../../../css/fuck.css', './chat.css'],
  providers: [
    EvsUserService,
    TicketService,
    BsModalService,
    ContactService,
    RoomService,
    UserService,
    TemplateService,
    DownloadService,
    CommonService,
    CoreTemplateService,
  ],
})
@Injectable()
export class ChatComponent extends BaseComponent {
  @ViewChild('lgModal') lgModal: ModalDirective;
  @ViewChild('agentsInQueue') agentsInQueue: ElementRef;
  @ViewChild('lgModalInvite') lgModalInvite: ModalDirective;
  modalRef: BsModalRef;
  public pageLoading = false;

  public list: any = [];
  public list_devide_page: any = [];
  isSorting: any = {};
  image_agent = 'assets/images/agent.jpg';
  image_contact = 'assets/images/contact.png';
  no_image = 'assets/images/contact.png';
  public messages: any = [];
  ioConnection: any;
  ioConnection1: any;
  transferConnection: any;
  inviteConnection: any;
  public message: any;
  public ticket_id: any;
  public allAccount: any = [];

  public currentPage = 1;
  public page_size = 10;
  public history: any = [];
  public alerts: any = {};
  public msg_list: any = {};
  public agent_onlines: any = [];
  public all_agent_onlines: any = [];
  public invite_msg = '';
  public msg_obj: any = {};
  public agents_in_ticket: any = [];
  public agents_id_in_ticket: any = [];
  public list_no_received: any = [];
  public can_leave = false;
  public can_forward = false;
  public can_receive = false;
  public onlines: any = {};
  public agents_status: any = {};
  public tab = 'online';
  public sender: any = null;

  public inputTicket: any = null;
  public btnHistory = true;
  public currentTicket: any = null;

  public modelFilter: any = {};
  public listAgent: any = [];
  public allRoom: any = [];
  public totalItem = 0;
  public totalPage = 0;
  public currentPage_agent = 1;
  public room_id: any;
  public friend: any = {};
  public url_server: any = environment.api_evs;
  public templates: any = [];
  public allTemplate: any = [{ id: '', text: '' }];
  public chatTemplate: any;
  public limit = 10;
  public totalList = 0;
  public isLoad = false;
  public keyword = '';
  public totalChats = 0;
  public total_chat_offline = 0;
  public total_chat_unread = 0;
  public first_load_offline = true;
  @ViewChild('confirm_chat') confirmChat: ElementRef;
  protected readonly TimeWorker = new TimeWorker();

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private userService: UserService,
    private contactService: ContactService,
    private chatService: ChatService,
    private ticketService: TicketService,
    private socketService: SocketService,
    private roomService: RoomService,
    private uploadService: UploadService,
    private notifycationService: PushNotificationsService,
    private templateService: TemplateService,
    private downloadService: DownloadService,
    private commonService: CommonService,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private chatListener: ChatListener,
    private coreTemplateService: CoreTemplateService
  ) {
    super(changeDetector, toastr, modalService);
    this.pageLoading = false;
    this.initIoConnection();
    this.socketService.missionAnnounced$.subscribe(mission => {
      if (mission.action == 'updateChatData') {
        this.loadData().subscribe();
      }
    });
    this._filter = this.activeRoute.snapshot.paramMap.get('type') as ChatFilterType;
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const type = this.activeRoute.snapshot.paramMap.get('type');
        if (this._filter === type) {
          return;
        }
        if (!isValidFilter(type)) {
          this.filter = ChatFilterType.All;
        }
        this.filter = type as ChatFilterType;
      }
    });
    this.chatListener.countUnreadChat.subscribe(res => {
      const { unreadMessage, offlineChannel } = res;
      this.total_chat_unread = unreadMessage;
      this.total_chat_offline = offlineChannel;
    });
  }

  private _filter: ChatFilterType = ChatFilterType.All;

  public get filter() {
    return this._filter;
  }

  public set filter(value: ChatFilterType) {
    this._filter = value;
    this.keyword = '';
    this.tab = 'online';
    this.messages = [];
    this.list = [];
    this.sender = null;
    this.history = [];
    this.ticket_id = null;
    this.currentTicket = null;
    this.list_devide_page = [];
    this.loadData().subscribe();
  }

  ngOnInit() {
    // this.setLoading(true)
    this.isSorting['field'] = 'created_at';
    this.isSorting['typeSort'] = 'desc';
    this.loadDataOffline(false).then();
    this.tab = 'online';
    this.loadData().subscribe(() => {
      this.pageLoading = true;
      this.getTemplate();
      this.getTotalChatTicket();
      const { channel, data } = this.chatListener.chatOpened;
      if (channel && channel !== 'unread') {
        this.tab = 'offline';
        this.loadDataOffline().then();
      }
      const chat = this.list.find(c => c._id === data.ticket_id);
      if (chat) {
        this.ticket_id = chat._id;
        this.inputTicket = chat;
      }
      if (this.ticket_id && this.inputTicket) {
        this.viewChat(this.ticket_id, true, this.inputTicket).then();
      }
      this.chatListener.chatOpened = {
        channel: 'unread',
        data: {},
      };
    });
  }

  ngOnDestroy() {
    if (this.inviteConnection) {
      this.inviteConnection.unsubscribe();
    }
    if (this.transferConnection) {
      this.transferConnection.unsubscribe();
    }
  }

  getAgentOnline(type) {
    const payload = {};
    if (this.currentTicket && this.currentTicket.source) {
      if (this.currentTicket.source_detail == 'chat') {
        payload['is_chat'] = true;
      } else if (this.currentTicket.source_detail == 'facebook') {
        payload['is_facebook'] = true;
      } else if (this.currentTicket.source_detail == 'zalo') {
        payload['is_zalo'] = true;
      }
    } else {
      payload['is_all'] = true;
    }

    this.chatService.agentOnlines(payload).subscribe(res => {
      if (res.status == 200 && res.error == false) {
        this.agent_onlines = res.data;
        this.all_agent_onlines = this.agent_onlines;
        if (type == 'invite') {
          this.agent_onlines = _.map(this.agent_onlines, e => {
            const check = _.find(this.agents_in_ticket, { id: e._id });
            if (!check) {
              return e;
            }
            return e;
          });
        }
      }
    });
  }

  getTemplate(request: any = {}, sort: any = {}) {
    this.coreTemplateService.list('chat', {}).subscribe(res => {
      this.templates = res.data.data;
      const templateList = [];
      res.data.data.forEach((c: any) => {
        templateList.push({
          id: c.id,
          text: c.template_name,
        });
      });
      this.allTemplate = templateList;
    });
  }

  useTemplate(id) {
    const template = this.templates.find(x => x.id == id);
    if (template) {
      this.message = template.template_content;
    }
    if (template.attach_file) {
      this.chatTemplate = {
        chatter_id: this.user._id,
        chatter_name: this.user.name,
        chatter_type: 'agent',
        content: template.attach_file,
        type: 'file', // image , file
        avatar: this.user.avatar ? this.user.avatar : '',
        date: Date.now(),
      };
    }
  }

  changeTab(type, _ticket_id?: any) {
    this.setLoading(true);
    this.keyword = '';
    this.tab = type;
    this.messages = [];
    this.list = [];
    this.sender = null;
    this.history = [];
    this.ticket_id = null;
    this.currentTicket = null;
    switch (type) {
      case 'online': {
        this.loadData().subscribe(res => {
          if (_ticket_id) {
            this.list_devide_page.forEach(item => {
              if (item._id == _ticket_id) {
                this.viewChat(item._id, item.receiver_id, item);
              }
            });
          }
        });
        this.getAgentOnline(null);
        break;
      }
      case 'offline': {
        this.loadDataOffline().then();
        break;
      }
      default:
        break;
    }
  }

  getParams() {
    switch (this._filter) {
      case ChatFilterType.Facebook:
        return ChatFilterType.Facebook;
      case ChatFilterType.Zalo:
        return ChatFilterType.Zalo;
      case ChatFilterType.Internal:
        return 'chat';
      case ChatFilterType.Live:
        return ChatFilterType.Live;
      default:
        return '';
    }
  }

  getTotalChatTicket() {
    const request = {
      filter: 'received',
    };

    const offLinerequest = { filter: 'no_received' };
    Observable.forkJoin([this.chatService.list(request), this.chatService.list(offLinerequest)]).subscribe(
      (res: any[]) => {
        this.totalChats = res.reduce((result, next) => {
          if (next.status !== 200 || !next.data) {
            return result;
          }

          return result + next.data.total;
        }, 0);
      }
    );
  }

  loadData() {
    this.tab = 'online';
    const request = {
      limit: this.limit,
      keyword: this.keyword ? this.keyword.trim() : '',
    };
    const source = this.getParams();
    if (source === 'chat') {
      return this.chatService.listInternal(request).map(res => {
        this.tab = 'internal';
        if (res.status == 200 && res.error == false) {
          this.room_id = res.data._id;
          this.chatService.joinInternal(res.data._id, this.user._id);
        }
        this.setLoading(false);
        return res;
      });
    } else {
      if (source) {
        request['source'] = source;
      }
      request['filter'] = 'received';
      return this.chatService.list(request).map(res => {
        if (res.status == 200 && res.error == false) {
          this.isLoad = false;
          this.list = res.data.list;
          this.totalList = !source ? res.data.total : this.totalList;
          let unread = 0;
          const ticketIds = [];
          this.list.forEach(e => {
            this.alerts[e._id] = e ? e.unread : 0;
            if (e.unread > 0) {
              unread += e.unread;
            }
            ticketIds.push(e._id);
            this.msg_list[e._id] = e ? e.last_msg : '';
            this.onlines[e._id] = e ? e.is_online : 0;
          });
          if (this._filter === 'all') {
            this.chatListener.updateUnreadMessage(unread, ticketIds, true);
          }
          this.list_devide_page = this.list.slice(0, this.limit); // Khi tìm kiếm keyword sẽ gán limit =9999 ở phía server nên this.list cso thể rất lớn
        }
        this.setLoading(false);
        return res;
      });
    }
  }

  async loadDataOffline(isSearch = true) {
    this.tab = 'offline';
    this.ticket_id = null;
    this.history = [];
    this.agents_in_ticket = [];
    const request = { filter: 'no_received' };
    request['keyword'] = this.keyword ? this.keyword.trim() : '';
    const source = this.getParams();
    if (source) {
      request['source'] = source;
    }
    this.chatService.list(request).subscribe(res => {
      if (res.status == 200 && res.error == false) {
        const temp = res.data.list;
        const listOffline = [];
        if (temp.length == 0) {
          this.ticket_id = null;
        }
        let amme = false;
        temp.forEach(e => {
          amme = false;
          if (
            (e.agent_uid && e.agent_uid == this.user._id) ||
            this.user.role == 'administrator' ||
            this.user.role == 'supervisor'
          ) {
            amme = true;
          } else {
            if (e.in_room) {
              e.in_room.forEach(id => {
                if (id == this.user._id) {
                  amme = true;
                }
              });
            }
          }
          if (amme) {
            listOffline.push(e);
            this.alerts[e._id] = e ? e.unread : 0;
            this.msg_list[e._id] = e ? e.last_msg : '';
          }
        });
        if (this._filter === 'all') {
          this.chatListener.updateOfflineChannel(listOffline.length, true);
        }
        if (isSearch) {
          this.list = listOffline;
          this.isLoad = false;
          this.totalList = res.data.total;
          this.list_devide_page = this.list.slice(0, this.limit);
        }
      }
      this.setLoading(false);
    });
  }

  loadAgentsInTicket(ticket_id) {
    this.agents_in_ticket = [];
    this.agents_id_in_ticket = [];
    this.chatService.agentsInTicket(ticket_id, {}).subscribe(res => {
      if (res.status == 200 && res.error == false) {
        this.agents_in_ticket = res.data;
        this.agents_in_ticket.forEach(e => {
          this.agents_status[e.id] = e.is_online;
          this.agents_id_in_ticket.push(e._id);
        });
      }
    });
  }

  /**
   * kết thúc trao đôi ticket chuyển trang thái close
   * @param ticket
   */
  finish(ticket_id) {
    const y = confirm('Bạn có muốn kết thúc trao đổi tại đây không?');
    if (y) {
      const _msg = {
        chatter_id: this.user._id,
        agent_id: this.user._id,
        device_id: localStorage.getItem('agentId'),
        chatter_name: this.user.name,
        chatter_type: 'agent',
        content: '',
        type: 'action-end', // image , file
        avatar: this.user.avatar ? this.user.avatar : '',
        date: Date.now(),
        source_detail: this.currentTicket.source_detail,
        ticket_id: ticket_id,
        ott_user_id: this.currentTicket.ott_user_id,
        page_id: this.currentTicket.page_id,
      };
      this.chatService.send(ticket_id, _msg);
      this.saveToTicket(ticket_id);
      this.ticketService.update(ticket_id, { status: 5 }).subscribe(res => {
        if (res.status == 200 && res.error == false) {
          this.currentTicket['status'] = 5;
          // setTimeout(() => {
          //     this.loadData().subscribe();
          // }, 2000);
          this.loadData().subscribe();
        }
      });
      // goi api ottgateway de end chat
      this.chatService.closeChat(_msg).subscribe(
        res => {
          // if (res.status == 200 && res.error == false) {
          //     this.loadData().subscribe();
          // }
        },
        error => {
          console.log('end chat error', ticket_id);
        }
      );
    }
  }

  /**
   * Tiếp nhận cuộc hội thoại chưa ai nhận
   * @param ticket_id
   * @param _ticket
   */
  receiverTicket(ticket_id) {
    if (this.tab == 'offline') {
      this.ticketService
        .updateMany({ _id: ticket_id, receiver_id: null }, { receiver_id: this.user._id })
        .subscribe(res => {
          if (res.status == 200 && res.error == false) {
            this.changeTab('online', ticket_id);
            this.chatListener.updateOfflineChannel(-1);
            this.chatService.send(ticket_id, {
              chatter_id: this.user._id,
              chatter_name: this.user.name,
              chatter_type: 'agent',
              content: '',
              type: 'action-join', // image , file
              avatar: '',
              date: Date.now(),
              ott_user_id: this.currentTicket ? this.currentTicket.ott_user_id : null,
              page_id: this.currentTicket ? this.currentTicket.page_id : null,
            });
          }
        });
    }
  }

  @HostListener('scroll', ['$event'])
  onScroll(event: any) {
    if (event.target.offsetHeight + event.target.scrollTop === event.target.scrollHeight) {
      this.alerts[this.ticket_id] = 0;
    }
  }

  getAccounts() {
    this.userService.list().subscribe(res => {
      this.allAccount = res.data.staffs;
    });
  }

  getRooms() {
    this.roomService.allRoom().subscribe(res => {
      const roomList = [];
      res.data.forEach((c: any) => {
        roomList.push({
          text: c.name,
          id: c.id.toString(),
        });
      });
      this.allRoom = roomList;
    });
  }

  getStaffs(request: any = {}, sort: any = {}) {
    this.listAgent = [];
    request.offset = this.page_size * (this.currentPage_agent <= 0 ? 0 : this.currentPage_agent - 1);
    request.limit = this.page_size;
    if (Object.keys(sort).length == 2) {
      request['sort_by'] = sort.field + ':' + sort.typeSort;
    }
    this.userService.list(request).subscribe(res => {
      if (res.status == 200 && res.error == false) {
        this.listAgent = res.data.staffs;
        this.totalItem = res.data.total;
        const pageString = (this.totalItem / this.page_size).toString();
        const pageSplit = pageString.split('.');
        let last: any;
        let totalpage = parseInt(pageSplit[0]);
        if (pageSplit.length > 1) {
          last = pageSplit[1];
          if (parseInt(last) > 0) {
            totalpage++;
          }
        }
        this.totalPage = totalpage;
      } else {
        this.listAgent = [];
      }
    });
  }

  setPage(page: number) {
    if (page <= this.totalPage) {
      if (page < 1) {
        page = 1;
      }
      if (page != this.currentPage_agent) {
        this.currentPage_agent = page;
        this.getStaffs();
      }
    } else {
      page = this.totalPage;
      $('#inputPage').val(page);
      this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      if (page <= this.totalPage) {
        // this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
        if (page < 1) {
          page = 1;
        }
        if (page != this.currentPage_agent) {
          this.currentPage_agent = page;
          this.getStaffs();
        }
      }
    }
  }

  goPage2(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPage(toPage);
    }
  }

  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }

  filterAgent(event: any = null) {
    const options = {};
    if (!event) {
      if (this.modelFilter.filter_agent_phone && this.modelFilter.filter_agent_phone.trim() != '') {
        options['phone'] = this.modelFilter.filter_agent_phone;
      }
      if (this.modelFilter.room_id) {
        options['room_id'] = this.modelFilter.room_id;
      }
    } else {
      this.modelFilter = {};
    }

    this.getStaffs(options);
  }

  public changedFilterRoom(e: any): void {
    this.modelFilter.room_id = parseInt(e.value);
  }

  async viewChat(ticket_id, received?: any, ticket?: any) {
    this.setLoading(true);
    if (ticket) {
      this.currentTicket = ticket;
    }
    this.btnHistory = true;
    this.currentPage = 0;
    this.messages = [];
    const request = {};
    this.chatService.history(ticket_id, request).subscribe(res => {
      if (res.status == 200 && res.error == false) {
        this.history = res.data.history;
        setTimeout(() => {
          const chatContainer = document.getElementById('chatContainer');
          if (chatContainer) {
            chatContainer.scrollTop = chatContainer.scrollHeight;
          }
        }, 500);
        this.setLoading(false);
      }
    });

    this.ticket_id = ticket_id;
    this.agents_in_ticket = [];
    this.agents_status = {};
    this.loadAgentsInTicket(ticket_id);
    const data = { $set: { unread: 0 } };
    this.ticketService.updateMany({ _id: ticket_id }, data).subscribe(res => {});
    this.chatService.join(ticket_id);
    this.can_receive = false;
    this.can_leave = false;
    this.can_forward = false;
    if (ticket && ticket.receiver_id != this.user._id) {
      this.can_leave = true;
    }
    if (ticket && ticket.receiver_id == this.user._id) {
      this.can_forward = true;
    }
    if (ticket && ticket.assign_agent_id == this.user._id) {
      this.can_receive = true;
    }
    if (ticket && ticket.in_room) {
      ticket.in_room.forEach(e => {
        if (e == this.user._id) {
          this.can_receive = true;
        }
      });
    }
    await this.getSender(ticket.requester_id);
    this.socketService.updateChatNotify(this.alerts[ticket_id]);
    if (this.alerts[ticket_id] > 0 && this.tab === 'online') {
      this.chatListener.updateUnreadMessage(-ticket.unread || 0, [ticket_id]);
    }
    this.alerts[ticket_id] = 0;
  }

  async getSender(requester_id) {
    this.userService.find({ _id: requester_id }).subscribe(res => {
      this.sender = res.data;
      if (!_.isNil(this.sender)) {
        this.sender['type'] = this.sender.role == 'end_user' ? 'Khách hàng' : 'Chuyên viên';
      }
    });
  }

  leaveRoom() {
    this.ticketService.updateMany({ _id: this.ticket_id }, { $pull: { in_room: this.user._id } }).subscribe(res => {
      if (res.status == 200 && res.error == false) {
        this.chatService.leave(this.ticket_id);
        this.loadData().subscribe();
        this.chatService.send(this.ticket_id, {
          chatter_id: this.user._id,
          chatter_name: this.user.name,
          chatter_type: 'agent',
          content: '',
          type: 'action-leave', // image , file
          avatar: '',
          date: Date.now(),
          ott_user_id: this.currentTicket ? this.currentTicket.ott_user_id : null,
          page_id: this.currentTicket ? this.currentTicket.page_id : null,
        });

        this.history = [];
        this.messages = [];
        this.agents_in_ticket = [];
        this.ticket_id = null;
      }
    });
  }

  showHistory(page) {
    this.currentPage = page;
    const request = {};
    this.chatService.history(this.currentTicket.history[page]._id, request).subscribe(res => {
      if (res.status == 200 && res.error == false) {
        if (this.currentPage == this.currentTicket.history.length - 1) {
          this.btnHistory = false;
        }
        this.history = _.concat(res.data.history, this.history);
        // this.history = res.data.history;
      }
    });
  }

  saveToTicket(ticket_id) {
    this.chatService.saveToTicket(ticket_id).subscribe(res => {
      if (res.status == 200 && res.error == false) {
        this.toastr.success('Lưu trữ lịch sử chat thành công', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
      }
    });
  }

  forwardChat(agent_id) {
    const payload = {
      agent_id: agent_id,
      from_user_id: this.user._id,
      from_user: this.user.name,
      tenant_id: this.user.tenant_id,
      ticket_id: this.ticket_id,
      status: 'forward',
    };
    this.chatService.forwardChat(payload);
  }

  openUser(user) {
    this.socketService.opentab(user, 'user', 'edit');
  }

  openTicket(ticket_id: any) {
    this.ticketService.find(ticket_id).subscribe(rs => {
      if (rs.status == 200 && rs.error == false) {
        const _ticket = rs.data;
        _ticket._id = ticket_id;
        this.userService
          .find({ _id: _ticket.requester_id })
          .toPromise()
          .then(res => {
            if (res.status == 200 && res.error == false) {
              _ticket.request = res.data;
              this.socketService.opentab(_ticket, 'ticket', 'edit');
            }
          });
      }
    });
  }

  inviteChat(agent_id) {
    console.log('inviteChat ' + agent_id);
    this.chatService.inviteChat(agent_id, this.user._id, this.user.name, this.user.tenant_id, this.ticket_id, 'invite');
  }

  chatting() {
    if (this.message && this.message.trim() != '') {
      const _msg = {
        chatter_id: this.user._id,
        chatter_name: this.user.name,
        chatter_type: 'agent',
        content: this.message,
        type: 'text', // image , file
        avatar: this.user.avatar ? this.user.avatar : '',
        date: Date.now(),
        source: this.currentTicket.source,
        source_detail: this.currentTicket.source_detail,
        ott_user_id: this.currentTicket ? this.currentTicket.ott_user_id : null,
        page_id: this.currentTicket ? this.currentTicket.page_id : null,
      };
      this.messages.push(_msg);
      this.message = '';
      this.chatService.send(this.ticket_id, _msg);
    }
    if (this.chatTemplate) {
      this.chatService.send(this.ticket_id, this.chatTemplate);
      this.messages.push(this.chatTemplate);
      this.chatTemplate = null;
    }
    setTimeout(() => {
      const chatContainer = document.getElementById('chatContainer');
      if (chatContainer) {
        chatContainer.scrollTop = chatContainer.scrollHeight;
      }
      this.message = '';
    }, 200);
  }

  _keydownSearch(event: any) {
    console.log('enter key', event.keyCode);
    if (event.keyCode == 13) {
      this.limit = 10;
      this.tab == 'online' ? this.loadData().subscribe() : this.loadDataOffline();
    }
  }

  _keydown(event: any) {
    console.log('enter key', event.keyCode);
    if (event.keyCode == 13) {
      if (this.message && this.message.trim() != '') {
        const _msg = {
          chatter_id: this.user._id,
          chatter_name: this.user.name,
          chatter_type: 'agent',
          content: this.message,
          type: 'text', // image , file
          avatar: this.user.avatar ? this.user.avatar : '',
          date: Date.now(),
          source: this.currentTicket.source,
          source_detail: this.currentTicket.source_detail,
          ott_user_id: this.currentTicket ? this.currentTicket.ott_user_id : null,
          page_id: this.currentTicket ? this.currentTicket.page_id : null,
        };
        this.messages.push(_msg);
        this.msg_list[this.ticket_id] = _msg.content;

        this.chatService.send(this.ticket_id, _msg);
        setTimeout(() => {
          const chatContainer = document.getElementById('chatContainer');
          chatContainer.scrollTop = chatContainer.scrollHeight;
          this.message = '';
          if (this.list[0]._id != this.ticket_id) {
            this.list.unshift(this.list.splice(this.list.findIndex(e => e._id == this.ticket_id))[0]);
          }
        }, 200);
      }
    }
  }

  openModel(template: ElementRef, ticket_id?: any) {
    this.ticket_id = ticket_id;
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-lg',
    };
    this.modalRef = this.modalService.show(template, config);
  }

  selectFriend(friend) {
    if (friend._id != this.user._id) {
      this.friend = friend;
      const config = {
        backdrop: true,
        ignoreBackdropClick: true,
        keyboard: false,
      };
      this.modalRef = this.modalService.show(this.confirmChat, config);
    }
  }

  chatInternal(friend_id) {
    if (friend_id != this.user._id) {
      this.chatService.internalChat(friend_id).subscribe(res => {
        this.tab = 'internal';
        if (res.status == 200 && res.error == false) {
          this.room_id = res.data._id;
          this.chatService.joinInternal(res.data._id, this.user._id);
        }
      });
    }
  }

  uploadFile(type) {
    if (type == 'image') {
      $('#messageImage').trigger('click');
    } else if (type == 'file') {
      $('#messageFile').trigger('click');
    }
  }

  sendFile($event, type) {
    const files = $event.srcElement.files;
    const file = files[0];
    if (file.size > 2 * 1024 * 1024) {
      this.toastr.error('Dung lượng file tối đa 2Mb', 'Lỗi', {
        timeOut: 3000,
        positionClass: 'toast-bottom-right',
      });
      return;
    }
    if (file.name.toLowerCase() == false && type == 'image') {
      this.toastr.error('Định dạng file gửi không đúng (png, jpg, jpeg)', 'Lỗi', {
        timeOut: 3000,
        positionClass: 'toast-bottom-right',
      });
      return;
    }
    if (/.*\.(docx|doc|xlsx|xls|pdf)$/.test(file.name.toLowerCase()) == false && type == 'file') {
      this.toastr.error('Định dạng file gửi không đúng (docx, doc, xlsx, xls, pdf)', 'Lỗi', {
        timeOut: 3000,
        positionClass: 'toast-bottom-right',
      });
      return;
    }
    this.uploadService.upload(file).then((res: any) => {
      if (!res.error) {
        const data = {
          chatter_id: this.user._id,
          chatter_name: this.user.name,
          chatter_type: 'agent',
          content: this.commonService.file(res.data),
          type: 'file', // image , file
          date: Date.now(),
          avatar: this.user.avatar ? this.user.avatar : '',
          source: this.currentTicket.source,
          source_detail: this.currentTicket.source_detail,
          ott_user_id: this.currentTicket ? this.currentTicket.ott_user_id : null,
          page_id: this.currentTicket ? this.currentTicket.page_id : null,
        };
        this.chatService.send(this.ticket_id, data);
        this.messages.push(data);
        setTimeout(() => {
          const chatContainer = document.getElementById('chatContainer');
          chatContainer.scrollTop = chatContainer.scrollHeight;
        }, 200);
        $event.target.value = null;
      } else {
        this.toastr.error(res.data.message, 'Lỗi', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
      }
    });
  }

  download_file(fileUrl) {
    const fileName = this.get_name_file(fileUrl);
    this.downloadService.downloadFile(fileUrl, fileName);
  }

  get_name_file(file) {
    const arr = file.split('/');
    return arr.pop();
  }

  isImage(file) {
    let check = false;
    const extension = file.substr(file.lastIndexOf('.') + 1);
    switch (extension) {
      case 'jpg':
      case 'png':
      case 'gif':
      case 'jpeg':
        check = true;
        break; // the alert ended with pdf instead of gif.
      default:
        break;
    }
    return check;
  }

  url_file(file) {
    if (file.indexOf('http') != -1) {
      return file;
    } else {
      return environment.api_evs + '/' + file;
    }
  }

  handleAction(type, value) {
    switch (type) {
      case 'open_user':
        this.openUser(value);
        break;
      case 'history':
        this.showHistory(this.currentPage + 1);
        break;
      case 'agent_in_queue':
        this.openModel(this.agentsInQueue, value);
        break;
      case 'invite':
        this.getAgentOnline('invite');
        this.lgModalInvite.show();
        break;
      case 'open_ticket':
        this.openTicket(value);
        break;
      case 'save_to_ticket':
        this.saveToTicket(value);
        break;
      case 'receiver':
        this.receiverTicket(value);
        break;
      case 'finish':
        this.finish(value);
        break;
      case 'scroll':
        this.onScroll(value);
        break;
      case '_keydown':
        this._keydown(value);
        break;
      case 'use_template':
        this.useTemplate(value);
        break;
      case 'send_image':
        this.sendFile(value, 'image');
        break;
      case 'send_file':
        this.sendFile(value, 'file');
        break;
      case 'chatting':
        this.message = value;
        this.chatting();
        break;
    }
  }

  @HostListener('scroll', ['$event'])
  onLazyload(event: any) {
    const totalScroll1 = event.target.offsetHeight + Math.round(event.target.scrollTop) - 1;
    const totalScroll2 = event.target.offsetHeight + Math.round(event.target.scrollTop);
    const totalScroll3 = event.target.offsetHeight + Math.round(event.target.scrollTop) + 1;
    const scrollHeight = event.target.scrollHeight;
    if (
      (totalScroll1 === scrollHeight || totalScroll2 === scrollHeight || totalScroll3 === scrollHeight) &&
      !this.isLoad &&
      this.totalList >= this.limit
    ) {
      setTimeout(() => {
        this.limit += 10;
        this.isLoad = true;
        if (this.tab != 'offline') {
          this.loadData().subscribe();
        } else {
          this.loadDataOffline().then();
        }
      }, 500);
    }
  }

  private initIoConnection(): void {
    // this.chatService.initSocket(this.user.tenant_id, this.user._id);

    this.ioConnection = this.chatService.onMessage().subscribe((message: any) => {
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].requester_id == message.chatter_id) {
          message.avatar = this.list[i].requester_avatar;
          break;
        }
      }
      const room_id = message.room_id;
      if (this.ticket_id != room_id) {
        this.alerts[room_id] = this.alerts[room_id] + 1;
        this.chatListener.updateUnreadMessage(1, [room_id]);
      }
      this.msg_list[room_id] = message.content;
      this.onlines[room_id] = 1;
      if (this.ticket_id == room_id) {
        this.messages.push(message);
      }

      setTimeout(() => {
        const chatContainer = document.getElementById('chatContainer');
        if (chatContainer) {
          chatContainer.scrollTop = chatContainer.scrollHeight;
        }
        if (this.list && this.list[0] && this.list[0].requester_id != message.chatter_id) {
          this.list.unshift(this.list.splice(this.list.findIndex(e => e.requester_id == message.chatter_id))[0]);
        }
      }, 200);
    });

    this.chatService.onRefreshContact().subscribe((message: any) => {
      console.log('onRefreshContact ' + JSON.stringify(message));
      if (message.agent_id == this.user._id) {
        this.alerts[message.ticket_id] = this.alerts[message.ticket_id] ? this.alerts[message.ticket_id] + 1 : 1;
      }
    });

    this.chatService.onUpdateChatting().subscribe((message: any) => {
      console.log('onUpdateChatting ' + JSON.stringify(message));
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].requester_id == message.chatter_id) {
          message.avatar = this.list[i].requester_avatar;
          break;
        }
      }
      if (message.user_id == this.user._id) {
        if (this.currentTicket && this.currentTicket._id != message.ticket_id) {
          this.alerts[message.ticket_id] = this.alerts[message.ticket_id] ? this.alerts[message.ticket_id] + 1 : 1;
          this.chatListener.updateUnreadMessage(1, [message.ticket_id]);
          this.msg_list[message.ticket_id] = message.content;
          this.notifycationService.generateNotification([
            {
              title: message.chatter_name,
              content: message.content,
              avatar: message.avatar,
              icon: message.avatar,
              // icon: rs.data.avatar ? rs.data.avatar : this.no_image
            },
          ]);
        }
      }
    });

    this.chatService.onRefreshStatus().subscribe((message: any) => {
      console.log('onRefreshStatus ' + JSON.stringify(message));
      if (message.type == 'contact') {
        if (message.in_room && message.in_room.indexOf(this.user._id) > -1) {
          this.onlines[message.ticket_id] = message.status;
        }
      } else if (message.type == 'agent') {
        this.agents_status[message.agent_id] = message.status !== 0;
      }
    });

    this.chatService.onContactRequestChat().subscribe((message: any) => {
      console.log('onContactRequestChat ' + JSON.stringify(message));
      if (message.in_room && message.in_room.indexOf(this.user._id) > -1) {
        this.loadData().subscribe();
      }
    });

    this.inviteConnection = this.chatService.onInviteChat().subscribe((message: any) => {
      this.msg_obj = message;
      if (message.agent_id == this.user._id) {
        if (message.status == 'invite') {
        } else if (message.status == 'reject') {
          this.toastr.info(message.from_user + ' từ chối tham gia chat cùng', '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
        } else {
          this.loadAgentsInTicket(message.ticket_id);
        }
      }
    });

    this.transferConnection = this.chatService.onForwardChat().subscribe((message: any) => {
      this.msg_obj = message;
      if (message.agent_id == this.user._id) {
        if (message.status == 'forward') {
        } else if (message.status == 'reject') {
          this.toastr.info(message.from_user + ' từ chối tham gia hỗ trợ ', '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
        } else {
          this.history = [];
          this.agents_in_ticket = [];
          this.toastr.info(message.from_user + ' đồng ý hỗ trợ ', '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          this.chatService.leave(this.msg_obj.ticket_id);
          this.loadData().subscribe();
          this.loadAgentsInTicket(message.ticket_id);
          this.chatService.send(this.msg_obj.ticket_id, {
            chatter_id: this.user._id,
            chatter_name: this.user.name,
            chatter_type: 'agent',
            content: '',
            type: 'action-leave', // image , file
            avatar: '',
            date: Date.now(),
            ott_user_id: this.currentTicket ? this.currentTicket.ott_user_id : null,
            page_id: this.currentTicket ? this.currentTicket.page_id : null,
          });
          this.ticket_id = null;
        }
      }
    });

    this.chatService.onEvent('connect').subscribe(() => {
      console.log('connected');
    });

    this.chatService.onEvent('disconnect').subscribe(() => {
      console.log('disconnected');
    });
  }

  public showLastMessage(msg) {
    if (msg.length > 32) {
      msg = msg.substring(0, 32) + '...';
    }
    return msg;
  }

  public readonly showPhoneNumberInString = showPhoneNumberInString;
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/chat/chat.component.ts